export default function windowAddEvent(eventName, func) {
  let timer= null;
  window.addEventListener(eventName, ()=> {
      if(timer) {
          clearTimeout(timer);
      }
      timer = setTimeout(()=> {
          func && func();
          timer = null;
      }, 300)
  });
}
